module.exports = __webpack_public_path__ + "img/63.5fa6dffc.jpg";